import { GaEventsCollection } from '@wpro/google-analytics'

export function gtmTrackGA4Event (event: GaEventsCollection): void {
  (window as any)?.dataLayer?.push({
    event: event.name,
    eventModel: event.params
  })
}
